var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskSomeday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3811 28.6245C15.127 28.3742 15 28.0778 15 27.7353C15 27.3936 15.127 27.0975 15.3811 26.8472L22.8245 19.5125L15.3557 12.1528C15.1186 11.9192 15 11.6271 15 11.2767C15 10.9262 15.127 10.6258 15.3811 10.3755C15.6351 10.1252 15.9359 10 16.2834 10C16.6303 10 16.9307 10.1252 17.1848 10.3755L25.7206 18.8116C25.8222 18.9117 25.8943 19.0202 25.937 19.137C25.979 19.2538 26 19.379 26 19.5125C26 19.646 25.979 19.7712 25.937 19.888C25.8943 20.0048 25.8222 20.1133 25.7206 20.2134L17.1594 28.6495C16.9222 28.8832 16.6303 29 16.2834 29C15.9359 29 15.6351 28.8748 15.3811 28.6245Z",
    fill: "#F4BA40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#DDDDDD",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSomeday);
export default __webpack_public_path__ + "static/media/task_someday.d783e258e78eb3ad499ba053c808ae92.svg";
export { ForwardRef as ReactComponent };